export const featuresConfig = [
  {
    flag: 'example',
    description: 'An example feature flag',
    enabled: {
      development: true,
      production: false,
    },
  },
  {
    flag: 'data-export',
    description: 'Enable data export on data tables',
    enabled: {
      development: false,
      production: false,
    },
  },
  {
    flag: 'data-export-items',
    description: 'Enable data export for items data table',
    enabled: {
      development: false,
      production: false,
    },
  },
  {
    flag: 'sub-wallet-name-edit',
    description: 'Enable editing of sub-wallets names',
    enabled: {
      development: true,
      production: true,
    },
  },
  {
    flag: 'v2_flag',
    description:
      'Render the v2 UI shell (redesigned sidebar) in place of the v1 shell',
    enabled: {
      development: false,
      production: false,
    },
  },
] as const;

export default featuresConfig;
